import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useState } from 'react';
import PropTypes from "prop-types";
import * as stylex from '@stylexjs/stylex';
import { styling } from "noood/styles/styles.stylex";
import Icon from "noood/comp/ui/feather-icon/Icon";
import IconButton from "noood/comp/button/IconButton";
import Row from "noood/comp/ui/containers/flex-boxes/Row";
export default function EntityPropertyBox(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  return /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.entityPropertyContainer, props.stylex), {
    style: props.style,
    onMouseEnter: function onMouseEnter(e) {
      return setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave(e) {
      return setIsHovered(false);
    }
  }), /*#__PURE__*/React.createElement(Row, {
    gap: 3,
    style: {
      position: "relative",
      wordBreak: "break-all"
    }
  }, props.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: "".concat(props.icon),
    color: "var(--shade-30)",
    size: 14
  }), /*#__PURE__*/React.createElement("div", stylex.props(styling.meta, ui.flex1), props.label), isHovered && props.canCopy && /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      right: 0,
      top: 0
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: "copy"
  }))), props.value, props.caption && /*#__PURE__*/React.createElement("div", {
    className: "text-secondary"
  }, props.caption));
}
EntityPropertyBox.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

// @ts-ignore
_inject(".ev98rzlu{flex:1}", 2000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev16kvzi7{border-radius:var(--more-roundness)}", 2000);
_inject(".ev6w2896{padding:15px}", 1000);
var ui = {
  flex1: {
    "EntityPropertyBox__ui.flex1": "EntityPropertyBox__ui.flex1",
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    $$css: true
  },
  entityPropertyContainer: {
    "EntityPropertyBox__ui.entityPropertyContainer": "EntityPropertyBox__ui.entityPropertyContainer",
    backgroundColor: "ev1y7ric0",
    borderRadius: "ev16kvzi7",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "ev6w2896",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    $$css: true
  }
};